'use client';

import { createContext } from 'react';

import type { InlineFeedbackRootContextInterface } from '../types/inline-feedback-root.types';

export const InlineFeedbackRootContext = createContext<InlineFeedbackRootContextInterface>({});

InlineFeedbackRootContext.displayName = 'InlineFeedback.Root.Context';
